import { useState, useEffect, useCallback } from 'react';
import { getCustomer } from '../utils/api';

export const useCustomerData = (customerId) => {
	const [customer, setCustomer] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const fetchCustomer = useCallback(async () => {
		if (!customerId) {
			setLoading(false);
			return;
		}

		try {
			const response = await getCustomer(customerId);
			if (!response.ok) {
				throw new Error('Failed to load customer');
			}
			const data = await response.json();
			setCustomer(data.data);
			setError(null);
		} catch (err) {
			setError(err.message);
			console.error(err);
		} finally {
			setLoading(false);
		}
	}, [customerId]);

	useEffect(() => {
		fetchCustomer();
	}, [fetchCustomer]);

	const refresh = useCallback(async () => {
		if (!customerId) return;
		try {
			const response = await getCustomer(customerId);
			if (!response.ok) {
				throw new Error('Failed to refresh customer');
			}
			const data = await response.json();
			setCustomer(data.data);
			setError(null);
		} catch (err) {
			setError(err.message);
			console.error(err);
		}
	}, [customerId]);

	return { customer, loading, error, refresh, setCustomer };
};

export default useCustomerData;
